export default function isCurrentTaskActivity(
  taskActivity,
  currentTaskActivityId,
  currentActivityId,
  currentMiniactivityType
) {
  return (
    taskActivity.id == currentTaskActivityId &&
    (currentMiniactivityType
      ? taskActivity.activityId == currentActivityId &&
        taskActivity.activityConf.miniactivityType == currentMiniactivityType
      : taskActivity.activityId == currentActivityId)
  );
}
